import { AuthLayout } from "@/layouts/AuthLayout";
import { useMobileScreen } from "@/shared/hooks/useMobileScreen";
import {
  Anchor,
  Flex,
  rem,
  rgba,
  Text,
  useMantineColorScheme,
} from "@mantine/core";
import { useForgotPasswordController } from "./hooks/useForgotPasswordController";
import { ForgotPasswordForm } from "./components/ForgotPasswordForm";
import { Link } from "react-router-dom";
import { IconArrowLeft } from "@tabler/icons-react";

function ForgotPasswordPage() {
  const { isMobileScreen } = useMobileScreen();
  const { colorScheme } = useMantineColorScheme();
  const { form, loading, handleForgotPassword, emailSent } =
    useForgotPasswordController();

  const email = form.values.email.trim();

  function ForgotPasswordFooter() {
    return (
      <Anchor
        c={"var(--mantine-color-R500-0)"}
        component={Link}
        td={"none"}
        style={{
          display: "flex",
          alignSelf: "center",
          flexDirection: "row",
          alignItems: "center",
          gap: rem(4),
        }}
        to={"/"}>
        <IconArrowLeft size={24} />
        <Text
          fz={16}
          fw={700}
          component="span">
          Voltar ao login
        </Text>
      </Anchor>
    );
  }

  return (
    <AuthLayout
      title={
        <Text
          component="h2"
          ff={"heading"}
          fw={700}
          fz={isMobileScreen ? 24 : 28}>
          {emailSent ? "Confira seu e-mail!" : "Esqueceu sua senha?"}
        </Text>
      }
      footer={emailSent ? null : <ForgotPasswordFooter />}>
      {emailSent ? (
        <>
          <Flex
            direction={"column"}
            gap={8}
            fw={500}
            fz={isMobileScreen ? 12 : 16}
            c={
              colorScheme === "light"
                ? "var(--mantine-color-D500-0)"
                : rgba("var(--mantine-color-L100-0)", 0.7)
            }>
            <Text
              component="p"
              fw={"inherit"}
              fz={"inherit"}>
              Se o seu e-mail estiver registrado em nosso sistema, em breve
              enviaremos um e-mail para redefinir sua senha{email && " para "}
              {email && <strong>{email}</strong>}.
            </Text>
            <Text
              component="p"
              fw={"inherit"}
              fz={"inherit"}>
              Caso não receba, verifique sua caixa de spam e confirme se o
              e-mail enviado está correto.
            </Text>
          </Flex>
          <Flex
            style={{ alignSelf: "flex-start" }}
            mt={32}>
            <ForgotPasswordFooter />
          </Flex>
        </>
      ) : (
        <>
          <Text
            mb={32}
            fz={isMobileScreen ? 12 : 18}
            c={
              colorScheme === "light"
                ? rgba("var(--mantine-color-D900-0)", 0.5)
                : rgba("var(--mantine-color-L100-0)", 0.5)
            }>
            Insira seu e-mail abaixo para receber instruções de como redefinir
            sua senha
          </Text>
          <ForgotPasswordForm
            form={form}
            loading={loading}
            onSubmit={handleForgotPassword}
          />
        </>
      )}
    </AuthLayout>
  );
}

export { ForgotPasswordPage };
